<template>
  <b-col :xl="big ? 4 : 2" :md="big ? 6 : 3" :sm="big ? 12 : 4" :cols="big ? 12 : 6" class="mb-4 text-center">
    <b-row>
      <b-col sm="12" class="text-center">
        <div>
          <b-modal v-model="showModal" hide-footer>
            <b-row>
              <b-col>
                <img :src="watermarked" style="width: 100%"/>
              </b-col>
            </b-row>
          </b-modal>
        </div>
        <div id="image" class="text-center" style="width: 100%; text-align: center;">
          <div v-if="isAdmin">{{page.weight}}</div>
          <a target="_blank" @click="showBigImage()">
            <div class="hovereffect" style="cursor: pointer !important;">
              <img class="img-responsive" v-bind:src="thumbnail" alt style="max-height: 100%;" />
              <div v-bind:class="{'overlay-borded': selected, 'overlay2': true}">
                <div v-if="selected" style="background-color: #ff0; height: 40px; margin-top: 0; padding-top: 0; color: green;">
                  <h1>{{selected}}</h1>
                </div>
                <h2></h2>
                <br/>
                <br/>
                <br/>
                <br/>
                <br/>
                <p>Ampliar</p>
              </div>
            </div>
          </a>
        </div>
      </b-col>
      <b-col>
        <strong>{{name}}</strong>
        <br/>
      </b-col>
      <b-col sm="12" v-if="!this.simpleVersion">
        <!--<span class="h6" v-for="item in categoriesTemplate" v-bind:key="item._id">-->
        <span class="h6" v-for="(tag, index) in categories" :key="index">
          <small><i class="fa fa-tag"></i> {{tag}} &nbsp;</small>
        </span>
      </b-col>
      <b-col sm="12">
        <div>
          <div
          style="margin-top: 10px; margin-right: 5px; color: #63c2de">
          <br/>
          <b-button v-if="page.isCover && page.customColorsVersion" pill variant="success" style="margin-bottom: 20px;" class="rounded-pill" @click="chooseColor">Usar com outra cor</b-button>
          <b-button v-if="!selected" pill :variant="actionVariant" class="rounded-pill" @click="selectPage">{{actionText}}</b-button>
          <b-button pill variant="warning" class="rounded-pill" v-if="selected" @click="unselectPage">Remover do eBook</b-button>
          </div>
        </div>
        <slot></slot>
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
import service from "./../../service";
import { isMobile } from "mobile-device-detect";

export default {
  name: "EbookPageBox",
  props: {
    classObj: {
      type: String,
      default: "theme-color w-75 rounded mb-3"
    },
    color: {
      type: String,
      default: "bg-secondary"
    },
    thumbnail: "",
    fullImage: "",
    watermarked: "",
    name: "",
    selected: 0,
    simpleVersion: false,
    actionText: {
      type: String,
      default: "Adicionar"
    },
    actionVariant: {
      type: String,
      default: "primary"
    },
    categories: undefined,
    big: false,
    freeForbidden: false,
    page: {},
    isAdmin: false
  },
  data: function() {
    return {
      isMobileScreen: isMobile,
      showModal: false,
      showForbiddenMessage: false
    };
  },
  computed: {
    templateName() {
      return localStorage.templateName;
    },
    whitelabelName() {
      return localStorage.whitelabelName;
    }
  },
  created: function() { 
    
  },
  methods: {
    chooseColor: function() {
      this.$router.push({ name: 'ChooseColor',query: {forceCustomSave: 1}, params: { id: this.page.customColorsVersion, customSavingUrl: "/ebook/" + this.$route.params.id + "/save-cover/", shouldAllow: true }});
    },
    selectPage: function() {
      this.$emit('page:selected', true);
      /*
      if (!this.$props.freeForbidden) {
        
      } else {
        this.showForbiddenMessage = true;
      }*/
    },
    unselectPage: function() {
      this.$emit('page:unselected', true);
    },
    saveTemplate: function() {
      this.selected = !this.selected;
      service
        .saveFavoriteTemplate({
          templateId: this.templateId
        })
        .then(
          response => {
          },
          () => {
            this.showError = true;
          }
        );
    },
    showBigImage: function() {
       this.showModal = true;
    },
    removeTemplate: function() {
      
      service
        .deleteFavoriteTemplate(this.templateId
        )
        .then(
          response => {
            this.showModal = false;
            //TODO: Emitir pra cima para dar refresh
            this.$emit("favoriteDeleted");
          },
          () => {
            this.showError = true;
          }
        );
    }
  }
};
</script>

<style scoped>
.hovereffect {
  width: wrap;
  height: wrap;
  float: left;
  overflow: hidden;
  position: relative;
  text-align: center;
  cursor: default;
}

.hovereffect .overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: hidden;
  top: 0;
  left: 0;
  padding: 50px 20px;
}

.overlay2 {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  padding: 50px 20px;
}

.overlay-borded {
  border-color: #ff0;
  border-style: solid;
  border-width: 10px;
}

.hovereffect .overlayStory {
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: hidden;
  top: 0;
  left: 0;
  padding: 50px 2px;
}

.hovereffect img {
  display: block;
  position: relative;
  max-width: none;
  width: calc(100%);
  backface-visibility: hidden;
}

.hovereffect:hover img {
  opacity: 0.4;
  filter: alpha(opacity=40);
}

.hovereffect h2 {
  text-transform: uppercase;
  color: #fff;
  text-align: center;
  position: relative;
  font-size: 17px;
  overflow: hidden;
  font-weight: bold;
  padding: 0.5em 0;
  background-color: transparent;
}

.hovereffect h2:after {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: #fff;
  font-weight: bold;
  content: "";
  -webkit-transition: -webkit-transform 0.35s;
  transition: transform 0.35s;
  -webkit-transform: translate3d(-100%, 0, 0);
  transform: translate3d(-100%, 0, 0);
}

.hovereffect:hover h2:after {
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

.hovereffect a,
.hovereffect p {
  font-weight: bold;
  font-size: 100%;
  color: #fff;
  opacity: 0;
  filter: alpha(opacity=0);
  -webkit-transition: opacity 0.35s, -webkit-transform 0.35s;
  transition: opacity 0.35s, transform 0.35s;
  -webkit-transform: translate3d(100%, 0, 0);
  transform: translate3d(100%, 0, 0);
}

.hovereffect:hover a,
.hovereffect:hover p {
  opacity: 1;
  filter: alpha(opacity=100);
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
}

/*
.favorited {
  color: red;
}
.notFavorited {
  color: black;
}
*/
</style>